import { useEffect } from "react";
const domainpath = process.env.REACT_APP_API_DOMAIN_ENDPOINT;
const ArtViewTracker = ({ artId }) => {
  // console.log(artId, "artId");

  useEffect(() => {
    const startTime = Date.now();
    let clicks = 0;

    const clickHandler = () => {
      clicks += 1;
    };

    const sendViewData = async () => {
      const timeSpent = (Date.now() - startTime) / 1000;

      try {
        const res = await fetch("https://ipapi.co/json/");
        const locationData = await res.json();

        const viewData = {
          site: window.location.hostname,
          referer: document.referrer,
          pageUrl: artId,
          clicks,
          lat: locationData.latitude,
          long: locationData.longitude,
          timeSpent,
          url: window.location.href,
        };
        // console.log(viewData, "viewData"); // this should now log

        const response = await fetch(`${domainpath}/api/view/track-view`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(viewData),
        });
        // console.log(response.status, "response");
      } catch (err) {
        console.error("Error sending view data:", err);
      }
    };

    window.addEventListener("click", clickHandler);
    window.addEventListener("beforeunload", sendViewData);

    // TESTING ONLY — TEMPORARY TIMER TO FIRE SEND FUNCTION
    const timer = setTimeout(sendViewData, 5000); // trigger after 5 seconds

    return () => {
      sendViewData(); // fires on unmount
      clearTimeout(timer);
      window.removeEventListener("click", clickHandler);
      window.removeEventListener("beforeunload", sendViewData);
    };
  }, [artId]);

  return null; // no UI needed
};

export default ArtViewTracker;
